import * as types from "../constants/actionTypes";

export const finishPayment = () => dispatch => {
  dispatch({
    type: types.GET_PAYMENT_FINISHED
  });
};



// WEBPACK FOOTER //
// ./src/actions/paymentFinishedActions.js